<template>
    <v-dialog v-model="dialog" max-width="1000" style="background-color: red;" v-resize="onResize">
        <v-card v-if="isReady" class="standard-row pt-2 pl-10 pb-7" style="border: 1px solid #000000; border-radius: 20px;">
            <v-card-title class="pa-0">
                <v-row no-gutters class="standard-row justify-end"
                    style="width: 100%; font-size: 12px; padding: 9px 14px 9px 0px;">
                    <div v-if="permissionBtnEditMode">
                        <v-btn v-if="!editFile" rounded color="#fb8c00"
                            class="font-theme white--text download-report-vendor-btn" @click="editFileData">
                            <v-icon class="mr-1">mdi-pen</v-icon> แก้ไขข้อมูล
                        </v-btn>
                        <v-btn v-if="editFile" rounded color="red" :disabled="loadingAddVender === true"
                            class="mr-3 font-theme white--text download-report-vendor-btn" @click="cancelEdit">
                            <v-icon class="mr-1">mdi-close</v-icon> ยกเลิก
                        </v-btn>

                        <v-btn v-if="editFile" rounded color="green" :loading="loadingAddVender"
                            class="font-theme white--text download-report-vendor-btn" @click="saveEditVender">
                            <v-icon class="mr-1">mdi-content-save</v-icon> บันทึก
                        </v-btn>
                    </div>
                </v-row>
            </v-card-title>
            <div class="scroll-theme vendor-detail-scroll">
                <v-form ref="vendorForm">
                <v-row no-gutters v-for="(item, key) in detailVendor" :key="`title_${key}`" class="standard-row font-theme pr-8">
                    <p style="font-size: 32px; font-weight: 700;" class="mb-0">{{ key }}</p>
                    <template v-if="key === 'Detail'">
                        <v-row no-gutters class="standard-row mb-7">
                            <v-col v-for="(eachItem, eachKey) in item" :key="`detail_${eachKey}`" cols="12" sm="6" md="6" lg="6" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="5" lg="6" style="font-weight: 700;" class="pr-sm-3">
                                        <v-icon v-show="windowSize.x < 960" size="15">mdi-play</v-icon> {{ eachKey }}
                                    </v-col>
                                    <v-col v-if="!editFile" cols="12" sm="12" md="7" lg="6" class="pr-sm-3">
                                        <span v-show="windowSize.x < 960">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{ eachItem }}
                                    </v-col>
                                    <v-col v-else-if="eachKey === 'Type Of Vendor'" cols="12" sm="12" md="7" lg="6" class="pr-sm-3">
                                    <v-autocomplete v-if="selectedBiz.tax_id === '0107544000094'"
                                        v-model="dataInputs.Detail['Type Of Vendor']"
                                        :items="typeOfVendorList"
                                        item-text="type"
                                        item-value="type"
                                        outlined
                                        dense
                                        hide-details
                                        class="dropdown-select"
                                        append-icon="mdi-chevron-down"
                                        color="black"
                                        required 
                                        :rules="textRules"
                                        >
                                        <template v-slot:item="{ item }">
                                            <v-list-item-content>
                                            <v-list-item-title
                                                class="font-theme"
                                            >
                                                {{ item.type }}
                                            </v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        </v-autocomplete>
                                        <v-text-field v-else hide-details outlined height="25"  :disabled="true" 
                                        type="text" color="black" class="py-0 font-theme border-radius-box margin-left-text-field total-value-pr-create-doc"></v-text-field>
                                    </v-col>
                                    <v-col v-else cols="12" sm="12" md="7" lg="6" class="pr-sm-3">
                                    <v-text-field hide-details outlined height="25" v-model="dataInputs[key][eachKey]" :rules="textRules"
                                        type="text" color="black" class="py-0 font-theme border-radius-box margin-left-text-field total-value-pr-create-doc">
                                    </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else-if="key === 'Address'">
                        <v-row no-gutters class="standard-row mb-7">
                            <v-col v-for="(eachItem, eachKey) in item" :key="`address_${eachKey}`" cols="12" sm="6" md="4" lg="4" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="4" lg="4" style="font-weight: 700;" class="pr-sm-3">
                                        <v-icon v-show="windowSize.x < 960" size="15">mdi-play</v-icon> {{ eachKey }}
                                    </v-col>
                                    <v-col v-if="!editFile" cols="12" sm="12" md="8" lg="8" class="pr-sm-3">
                                        <span v-show="windowSize.x < 960">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{ eachItem }}
                                    </v-col>
                                    <v-col v-else cols="12" sm="12" md="7" lg="6" class="pr-sm-3">
                                    <v-text-field hide-details outlined height="25" v-model="dataInputs[key][eachKey]"
                                        type="text" color="black" class="py-0 font-theme border-radius-box margin-left-text-field total-value-pr-create-doc">
                                    </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else-if="['Payment', 'Contact'].includes(key)">
                        <v-row no-gutters class="standard-row" :class="{ 'mb-7' : key == 'Payment'}">
                            <v-col v-for="(eachItem, eachKey) in item" :key="`payment_contact_${eachItem}${eachKey}`" cols="12" sm="6" md="6" lg="6" class="mt-3 mt-md-1" style="font-size: 14px;">
                                <v-row no-gutters class="standard-row">
                                    <v-col cols="12" sm="12" md="5" lg="6" style="font-weight: 700;" class="pr-sm-3">
                                        <v-icon v-show="windowSize.x < 960" size="15">mdi-play</v-icon> {{ eachKey }}
                                    </v-col>
                                    <v-col v-if="!editFile" cols="12" sm="12" md="7" lg="6" class="pr-sm-3">
                                        <span v-show="windowSize.x < 960">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{ eachItem }}
                                    </v-col>
                                    <v-col v-else cols="12" sm="12" md="7" lg="6" class="pr-sm-3">
                                    <v-text-field hide-details outlined height="25" v-model="dataInputs[key][eachKey]"
                                        type="text" color="black" class="py-0 font-theme border-radius-box margin-left-text-field total-value-pr-create-doc">
                                    </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                </v-row>
            </v-form>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
    export default {
        data: () => ({
            dialog: false,
            loadingAddVender: false,
            isReady: false,
            editFile: false,
            detailVendor: {},
            dataInputs: {},
            windowSize: { x: 0 },
            textRules: [v => !!v],
            typeOfVendorList: [
                {
                    "type": "Other"
                },
                {
                    "type": "ย่อย"
                },
                {
                    "type": "ร่วม-ร่วมค้า-ผู้ถือหุ้น"
                }
        ],                
        }),
        watch: {
        "dialog"(newVal) {
            if (!newVal) {
                this.dialog = false;
                setTimeout(() => {
                    this.editFile = false;
                }, 1000);
                }
            }
        },
        computed: {
            raDetail() {
            return this.$store.state.raDetail
            },
            permissionBtnEditMode(){
                return this.$store.state.permissionBtnEditMode
            },
            selectedBiz() {
            return this.$store.state.confirmSelectedBiz
            },
        },
        mounted () {
            EventBus.$on('openDetailVendor', this.openDialog)
        },
        beforeDestroy() {
            EventBus.$off('openDetailVendor')
        },
        methods: {
            openDialog(data,id) {
                this.IdDocVendor = id;
                this.isReady = false
                this.onResize()
                const { vendor_code, vendor_name_th, vendor_group_code, currency, branch_code, tax_id_vendor, pur_org, pur_group, head_office,
                        title_name, vendor_name_eng, vendor_group_name, prefix, description, address_code, pur_org_description, pur_group_description,type_of_vendor, tax_id,
                        house_no, building, village_no, lane, road, sub_district, district, province, postal_code,
                        payment_term, collection_term, creditor_account, clearing, vat_code, statement_term, debt_collection_conditions, creditor_name,
                        clearing_name, vat_code_name, contact_name, contact_note, contact_tel1, contact_fax, tel1, mobile, email,
                        contact_position, contact_mobile, contact_tel2, contact_email, tel2, fax, website } = data;
                this.detailVendor = {
                    Detail  : { vendor_code, title_name, vendor_name_th, vendor_name_eng, vendor_group_code, vendor_group_name, currency, prefix, branch_code, description, tax_id_vendor, address_code, pur_org, pur_org_description, pur_group, pur_group_description, head_office, type_of_vendor, tax_id },
                    Address : { house_no, building, village_no, lane, road, sub_district, district, province, postal_code },
                    Payment : { payment_term, statement_term, collection_term, debt_collection_conditions, creditor_account, creditor_name, clearing, clearing_name, vat_code, vat_code_name },
                    Contact : { contact_name, contact_position, contact_note, contact_mobile, contact_tel1, contact_tel2, contact_fax, contact_email, tel1, tel2, mobile, fax, email, website }
                }
                
                this.detailVendor.Detail['Vendor Code'] = this.detailVendor.Detail['vendor_code'];
                this.detailVendor.Detail['Title Name'] = this.detailVendor.Detail['title_name'];
                this.detailVendor.Detail['Vendor Name (TH)'] = this.detailVendor.Detail['vendor_name_th'];
                this.detailVendor.Detail['Vendor Name (ENG)'] = this.detailVendor.Detail['vendor_name_eng'];
                this.detailVendor.Detail['Vendor Group Code'] = this.detailVendor.Detail['vendor_group_code'];
                this.detailVendor.Detail['Vendor Group Name'] = this.detailVendor.Detail['vendor_group_name'];
                this.detailVendor.Detail['Currency'] = this.detailVendor.Detail['currency'];
                this.detailVendor.Detail['คำนำหน้าชื่อ'] = this.detailVendor.Detail['prefix'];
                this.detailVendor.Detail['Branch Code'] = this.detailVendor.Detail['branch_code'];
                this.detailVendor.Detail['Description'] = this.detailVendor.Detail['description'];
                this.detailVendor.Detail['Tax Id Vendor'] = this.detailVendor.Detail['tax_id_vendor'];
                this.detailVendor.Detail['Address Code'] = this.detailVendor.Detail['address_code'];
                this.detailVendor.Detail['Pur Org.'] = this.detailVendor.Detail['pur_org'];
                this.detailVendor.Detail['PurOrg - Description'] = this.detailVendor.Detail['pur_org_description'];
                this.detailVendor.Detail['Pur Group'] = this.detailVendor.Detail['pur_group'];
                this.detailVendor.Detail['PurGroup - Description'] = this.detailVendor.Detail['pur_group_description'];
                this.detailVendor.Detail['Head Office'] = this.detailVendor.Detail['head_office'];
                this.detailVendor.Detail['Type Of Vendor'] = this.detailVendor.Detail['type_of_vendor'];
                this.detailVendor.Detail['Tax Id'] = this.detailVendor.Detail['tax_id'];

                this.detailVendor.Address['เลขที่'] = this.detailVendor.Address['house_no'];
                this.detailVendor.Address['อาคาร'] = this.detailVendor.Address['building'];
                this.detailVendor.Address['หมู่ที่'] = this.detailVendor.Address['village_no'];
                this.detailVendor.Address['ซอย'] = this.detailVendor.Address['lane'];
                this.detailVendor.Address['ถนน'] = this.detailVendor.Address['road'];
                this.detailVendor.Address['แขวง'] = this.detailVendor.Address['sub_district'];
                this.detailVendor.Address['เขต'] = this.detailVendor.Address['district'];
                this.detailVendor.Address['จังหวัด'] = this.detailVendor.Address['province'];
                this.detailVendor.Address['รหัสไปรษณีย์'] = this.detailVendor.Address['postal_code'];

                this.detailVendor.Payment['เงื่อนไขการชำระเงิน'] = this.detailVendor.Payment['payment_term'];
                this.detailVendor.Payment['Statement Term'] = this.detailVendor.Payment['statement_term'];
                this.detailVendor.Payment['Collection Term'] = this.detailVendor.Payment['collection_term'];
                this.detailVendor.Payment['เงื่อนไขการติดตามหนี้'] = this.detailVendor.Payment['debt_collection_conditions'];
                this.detailVendor.Payment['บัญชีเจ้าหนี้'] = this.detailVendor.Payment['creditor_account'];
                this.detailVendor.Payment['ชื่อบัญชีเจ้าหนี้'] = this.detailVendor.Payment['creditor_name'];
                this.detailVendor.Payment['การหักบัญชี'] = this.detailVendor.Payment['clearing'];
                this.detailVendor.Payment['ชื่อการหักบัญชี'] = this.detailVendor.Payment['clearing_name'];
                this.detailVendor.Payment['รหัสภาษีมูลค่าเพิ่ม'] = this.detailVendor.Payment['vat_code'];
                this.detailVendor.Payment['ชื่อรหัสภาษีมูลค่าเพิ่ม'] = this.detailVendor.Payment['vat_code_name'];

                this.detailVendor.Contact['ชื่อผู้ติดต่อ'] = this.detailVendor.Contact['contact_name'];
                this.detailVendor.Contact['ผู้ติดต่อ - ตำแหน่ง'] = this.detailVendor.Contact['contact_position'];
                this.detailVendor.Contact['ผู้ติดต่อ - หมายเหตุ'] = this.detailVendor.Contact['contact_note'];
                this.detailVendor.Contact['ผู้ติดต่อ - Mobile'] = this.detailVendor.Contact['contact_mobile'];
                this.detailVendor.Contact['ผู้ติดต่อ - หมายเลขโทรศัพท์ติดต่อ 1'] = this.detailVendor.Contact['contact_tel1'];
                this.detailVendor.Contact['ผู้ติดต่อ - หมายเลขโทรศัพท์ติดต่อ 2'] = this.detailVendor.Contact['contact_tel2'];
                this.detailVendor.Contact['ผู้ติดต่อ - Fax'] = this.detailVendor.Contact['contact_fax'];
                this.detailVendor.Contact['ผู้ติดต่อ - E-Mail'] = this.detailVendor.Contact['contact_email'];
                this.detailVendor.Contact['Tel 1'] = this.detailVendor.Contact['tel1'];
                this.detailVendor.Contact['Tel 2'] = this.detailVendor.Contact['tel2'];
                this.detailVendor.Contact['Mobile'] = this.detailVendor.Contact['mobile'];
                this.detailVendor.Contact['Fax'] = this.detailVendor.Contact['fax'];
                this.detailVendor.Contact['E-Mail'] = this.detailVendor.Contact['email'];
                this.detailVendor.Contact['Website'] = this.detailVendor.Contact['website'];

                delete this.detailVendor.Detail['vendor_code'];
                delete this.detailVendor.Detail['title_name'];
                delete this.detailVendor.Detail['vendor_name_th'];
                delete this.detailVendor.Detail['vendor_name_eng'];
                delete this.detailVendor.Detail['vendor_group_code'];
                delete this.detailVendor.Detail['vendor_group_name'];
                delete this.detailVendor.Detail['currency'];
                delete this.detailVendor.Detail['prefix'];
                delete this.detailVendor.Detail['branch_code'];
                delete this.detailVendor.Detail['description'];
                delete this.detailVendor.Detail['tax_id_vendor'];
                delete this.detailVendor.Detail['address_code'];
                delete this.detailVendor.Detail['pur_org'];
                delete this.detailVendor.Detail['pur_org_description'];
                delete this.detailVendor.Detail['pur_group'];
                delete this.detailVendor.Detail['pur_group_description'];
                delete this.detailVendor.Detail['head_office'];
                delete this.detailVendor.Detail['type_of_vendor'];
                delete this.detailVendor.Detail['tax_id'];

                delete this.detailVendor.Address['house_no'];
                delete this.detailVendor.Address['building'];
                delete this.detailVendor.Address['village_no'];
                delete this.detailVendor.Address['lane'];
                delete this.detailVendor.Address['road'];
                delete this.detailVendor.Address['sub_district'];
                delete this.detailVendor.Address['district'];
                delete this.detailVendor.Address['province'];
                delete this.detailVendor.Address['postal_code'];

                delete this.detailVendor.Payment['payment_term'];
                delete this.detailVendor.Payment['statement_term'];
                delete this.detailVendor.Payment['collection_term'];
                delete this.detailVendor.Payment['debt_collection_conditions'];
                delete this.detailVendor.Payment['creditor_account'];
                delete this.detailVendor.Payment['creditor_name'];
                delete this.detailVendor.Payment['clearing'];
                delete this.detailVendor.Payment['clearing_name'];
                delete this.detailVendor.Payment['vat_code'];
                delete this.detailVendor.Payment['vat_code_name'];

                delete this.detailVendor.Contact['contact_name'];
                delete this.detailVendor.Contact['contact_position'];
                delete this.detailVendor.Contact['contact_note'];
                delete this.detailVendor.Contact['contact_mobile'];
                delete this.detailVendor.Contact['contact_tel1'];
                delete this.detailVendor.Contact['contact_tel2'];
                delete this.detailVendor.Contact['contact_fax'];
                delete this.detailVendor.Contact['contact_email'];
                delete this.detailVendor.Contact['tel1'];
                delete this.detailVendor.Contact['tel2'];
                delete this.detailVendor.Contact['mobile'];
                delete this.detailVendor.Contact['fax'];
                delete this.detailVendor.Contact['email'];
                delete this.detailVendor.Contact['website'];
                this.CopyDetailVendor = JSON.parse(JSON.stringify(this.detailVendor));
                this.$nextTick(() => {
                    this.dialog = true
                    this.isReady = true
                    document.getElementsByClassName('v-dialog--active')[0]? document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0: null
                })
                for (const [key, value] of Object.entries(this.detailVendor)) {
                    this.$set(this.dataInputs, key, value)
                }
            },
            async saveEditVender(){
                const isValid = this.$refs.vendorForm.validate()
                if (!isValid) return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                this.loadingAddVender = true;
                // Detail
                this.dataInputs.Detail['vendor_code'] = this.dataInputs.Detail['Vendor Code'];
                this.dataInputs.Detail['title_name'] = this.dataInputs.Detail['Title Name'];
                this.dataInputs.Detail['vendor_name_th'] = this.dataInputs.Detail['Vendor Name (TH)'];
                this.dataInputs.Detail['vendor_name_eng'] = this.dataInputs.Detail['Vendor Name (ENG)'];
                this.dataInputs.Detail['vendor_group_code'] = this.dataInputs.Detail['Vendor Group Code'];
                this.dataInputs.Detail['vendor_group_name'] = this.dataInputs.Detail['Vendor Group Name'];
                this.dataInputs.Detail['currency'] = this.dataInputs.Detail['Currency'];
                this.dataInputs.Detail['prefix'] = this.dataInputs.Detail['คำนำหน้าชื่อ'];
                this.dataInputs.Detail['branch_code'] = this.dataInputs.Detail['Branch Code'];
                this.dataInputs.Detail['description'] = this.dataInputs.Detail['Description'];
                this.dataInputs.Detail['tax_id_vendor'] = this.dataInputs.Detail['Tax Id Vendor'];
                this.dataInputs.Detail['address_code'] = this.dataInputs.Detail['Address Code'];
                this.dataInputs.Detail['pur_org'] = this.dataInputs.Detail['Pur Org.'];
                this.dataInputs.Detail['pur_org_description'] = this.dataInputs.Detail['PurOrg - Description'];
                this.dataInputs.Detail['pur_group'] = this.dataInputs.Detail['Pur Group'];
                this.dataInputs.Detail['pur_group_description'] = this.dataInputs.Detail['PurGroup - Description'];
                this.dataInputs.Detail['head_office'] = this.dataInputs.Detail['Head Office'];
                this.dataInputs.Detail['tax_id'] = this.dataInputs.Detail['Tax Id'];
                this.dataInputs.Detail['type_of_vendor'] = this.dataInputs.Detail['Type Of Vendor'];

                // Address
                this.dataInputs.Address['house_no'] = this.dataInputs.Address['เลขที่'];
                this.dataInputs.Address['building'] = this.dataInputs.Address['อาคาร'];
                this.dataInputs.Address['village_no'] = this.dataInputs.Address['หมู่ที่'];
                this.dataInputs.Address['lane'] = this.dataInputs.Address['ซอย'];
                this.dataInputs.Address['road'] = this.dataInputs.Address['ถนน'];
                this.dataInputs.Address['sub_district'] = this.dataInputs.Address['แขวง'];
                this.dataInputs.Address['district'] = this.dataInputs.Address['เขต'];
                this.dataInputs.Address['province'] = this.dataInputs.Address['จังหวัด'];
                this.dataInputs.Address['postal_code'] = this.dataInputs.Address['รหัสไปรษณีย์'];

                // Payment
                this.dataInputs.Payment['payment_term'] = this.dataInputs.Payment['เงื่อนไขการชำระเงิน'];
                this.dataInputs.Payment['statement_term'] = this.dataInputs.Payment['Statement Term'];
                this.dataInputs.Payment['collection_term'] = this.dataInputs.Payment['Collection Term'];
                this.dataInputs.Payment['debt_collection_conditions'] = this.dataInputs.Payment['เงื่อนไขการติดตามหนี้'];
                this.dataInputs.Payment['creditor_account'] = this.dataInputs.Payment['บัญชีเจ้าหนี้'];
                this.dataInputs.Payment['creditor_name'] = this.dataInputs.Payment['ชื่อบัญชีเจ้าหนี้'];
                this.dataInputs.Payment['clearing'] = this.dataInputs.Payment['การหักบัญชี'];
                this.dataInputs.Payment['clearing_name'] = this.dataInputs.Payment['ชื่อการหักบัญชี'];
                this.dataInputs.Payment['vat_code'] = this.dataInputs.Payment['รหัสภาษีมูลค่าเพิ่ม'];
                this.dataInputs.Payment['vat_code_name'] = this.dataInputs.Payment['ชื่อรหัสภาษีมูลค่าเพิ่ม'];

                // Contact
                this.dataInputs.Contact['contact_name'] = this.dataInputs.Contact['ชื่อผู้ติดต่อ'];
                this.dataInputs.Contact['contact_position'] = this.dataInputs.Contact['ผู้ติดต่อ - ตำแหน่ง'];
                this.dataInputs.Contact['contact_note'] = this.dataInputs.Contact['ผู้ติดต่อ - หมายเหตุ'];
                this.dataInputs.Contact['contact_mobile'] = this.dataInputs.Contact['ผู้ติดต่อ - Mobile'];
                this.dataInputs.Contact['contact_tel1'] = this.dataInputs.Contact['ผู้ติดต่อ - หมายเลขโทรศัพท์ติดต่อ 1'];
                this.dataInputs.Contact['contact_tel2'] = this.dataInputs.Contact['ผู้ติดต่อ - หมายเลขโทรศัพท์ติดต่อ 2'];
                this.dataInputs.Contact['contact_fax'] = this.dataInputs.Contact['ผู้ติดต่อ - Fax'];
                this.dataInputs.Contact['contact_email'] = this.dataInputs.Contact['ผู้ติดต่อ - E-Mail'];
                this.dataInputs.Contact['tel1'] = this.dataInputs.Contact['Tel 1'];
                this.dataInputs.Contact['tel2'] = this.dataInputs.Contact['Tel 2'];
                this.dataInputs.Contact['mobile'] = this.dataInputs.Contact['Mobile'];
                this.dataInputs.Contact['fax'] = this.dataInputs.Contact['Fax'];
                this.dataInputs.Contact['email'] = this.dataInputs.Contact['E-Mail'];
                this.dataInputs.Contact['website'] = this.dataInputs.Contact['Website'];

                const ListEditDetailVendor = {
                    // From Detail
                    "vendor_code": this.dataInputs.Detail.vendor_code,
                    "title_name": this.dataInputs.Detail.title_name,
                    "vendor_name_th": this.dataInputs.Detail.vendor_name_th,
                    "vendor_name_eng": this.dataInputs.Detail.vendor_name_eng,
                    "vendor_group_code": this.dataInputs.Detail.vendor_group_code,
                    "vendor_group_name": this.dataInputs.Detail.vendor_group_name,
                    "currency": this.dataInputs.Detail.currency,
                    "prefix": this.dataInputs.Detail.prefix,
                    "branch_code": this.dataInputs.Detail.branch_code,
                    "description": this.dataInputs.Detail.description,
                    "tax_id_vendor": this.dataInputs.Detail.tax_id_vendor,
                    "address_code": this.dataInputs.Detail.address_code,
                    "pur_org": this.dataInputs.Detail.pur_org,
                    "pur_org_description": this.dataInputs.Detail.pur_org_description,
                    "pur_group": this.dataInputs.Detail.pur_group,
                    "pur_group_description": this.dataInputs.Detail.pur_group_description,
                    "head_office": this.dataInputs.Detail.head_office,
                    "type_of_vendor": this.dataInputs.Detail.type_of_vendor,
                    "tax_id": this.dataInputs.Detail.tax_id,

                    // From Address
                    "house_no": this.dataInputs.Address.house_no,
                    "building": this.dataInputs.Address.building,
                    "village_no": this.dataInputs.Address.village_no,
                    "lane": this.dataInputs.Address.lane,
                    "road": this.dataInputs.Address.road,
                    "sub_district": this.dataInputs.Address.sub_district,
                    "district": this.dataInputs.Address.district,
                    "province": this.dataInputs.Address.province,
                    "postal_code": this.dataInputs.Address.postal_code,

                    // From Payment
                    "payment_term": this.dataInputs.Payment.payment_term,
                    "statement_term": this.dataInputs.Payment.statement_term,
                    "collection_term": this.dataInputs.Payment.collection_term,
                    "debt_collection_conditions": this.dataInputs.Payment.debt_collection_conditions,
                    "creditor_account": this.dataInputs.Payment.creditor_account,
                    "creditor_name": this.dataInputs.Payment.creditor_name,
                    "clearing": this.dataInputs.Payment.clearing,
                    "clearing_name": this.dataInputs.Payment.clearing_name,
                    "vat_code": this.dataInputs.Payment.vat_code,
                    "vat_code_name": this.dataInputs.Payment.vat_code_name,

                    // From Contact
                    "contact_name": this.dataInputs.Contact.contact_name,
                    "contact_position": this.dataInputs.Contact.contact_position,
                    "contact_note": this.dataInputs.Contact.contact_note,
                    "contact_tel1": this.dataInputs.Contact.contact_tel1,
                    "contact_tel2": this.dataInputs.Contact.contact_tel2,
                    "contact_mobile": this.dataInputs.Contact.contact_mobile,
                    "contact_fax": this.dataInputs.Contact.contact_fax,
                    "contact_email": this.dataInputs.Contact.contact_email,
                    "tel1": this.dataInputs.Contact.tel1,
                    "tel2": this.dataInputs.Contact.tel2,
                    "mobile": this.dataInputs.Contact.mobile,
                    "fax": this.dataInputs.Contact.fax,
                    "email": this.dataInputs.Contact.email,
                    "website": this.dataInputs.Contact.website,

                };
                    delete this.dataInputs.Detail['vendor_code'];
                    delete this.dataInputs.Detail['title_name'];
                    delete this.dataInputs.Detail['vendor_name_th'];
                    delete this.dataInputs.Detail['vendor_name_eng'];
                    delete this.dataInputs.Detail['vendor_group_code'];
                    delete this.dataInputs.Detail['vendor_group_name'];
                    delete this.dataInputs.Detail['currency'];
                    delete this.dataInputs.Detail['prefix'];
                    delete this.dataInputs.Detail['branch_code'];
                    delete this.dataInputs.Detail['description'];
                    delete this.dataInputs.Detail['tax_id_vendor'];
                    delete this.dataInputs.Detail['address_code'];
                    delete this.dataInputs.Detail['pur_org'];
                    delete this.dataInputs.Detail['pur_org_description'];
                    delete this.dataInputs.Detail['pur_group'];
                    delete this.dataInputs.Detail['pur_group_description'];
                    delete this.dataInputs.Detail['head_office'];
                    delete this.dataInputs.Detail['type_of_vendor'];
                    delete this.dataInputs.Detail['tax_id'];

                    delete this.dataInputs.Address['house_no'];
                    delete this.dataInputs.Address['building'];
                    delete this.dataInputs.Address['village_no'];
                    delete this.dataInputs.Address['lane'];
                    delete this.dataInputs.Address['road'];
                    delete this.dataInputs.Address['sub_district'];
                    delete this.dataInputs.Address['district'];
                    delete this.dataInputs.Address['province'];
                    delete this.dataInputs.Address['postal_code'];

                    delete this.dataInputs.Payment['payment_term'];
                    delete this.dataInputs.Payment['statement_term'];
                    delete this.dataInputs.Payment['collection_term'];
                    delete this.dataInputs.Payment['debt_collection_conditions'];
                    delete this.dataInputs.Payment['creditor_account'];
                    delete this.dataInputs.Payment['creditor_name'];
                    delete this.dataInputs.Payment['clearing'];
                    delete this.dataInputs.Payment['clearing_name'];
                    delete this.dataInputs.Payment['vat_code'];
                    delete this.dataInputs.Payment['vat_code_name'];

                    delete this.dataInputs.Contact['contact_name'];
                    delete this.dataInputs.Contact['contact_position'];
                    delete this.dataInputs.Contact['contact_note'];
                    delete this.dataInputs.Contact['contact_mobile'];
                    delete this.dataInputs.Contact['contact_tel1'];
                    delete this.dataInputs.Contact['contact_tel2'];
                    delete this.dataInputs.Contact['contact_fax'];
                    delete this.dataInputs.Contact['contact_email'];
                    delete this.dataInputs.Contact['tel1'];
                    delete this.dataInputs.Contact['tel2'];
                    delete this.dataInputs.Contact['mobile'];
                    delete this.dataInputs.Contact['fax'];
                    delete this.dataInputs.Contact['email'];
                    delete this.dataInputs.Contact['website'];
                try {
                    const { data } = await this.axios.put(`${this.$api_url}/vendor_erp/api/v1/edit_vendor/${this.IdDocVendor}`, ListEditDetailVendor)
                    if (data.status) {
                        this.dialog = false;
                        this.editFile = false;
                        this.alert('เพิ่มข้อมูลสำเร็จ', 'Success', 'success')
                        setTimeout(() => {
                            EventBus.$emit('reloadPage');
                        }, 1000);
                    } else {
                        this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                    }
                } catch (error) {
                    this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                    console.log(error);
                }finally {
                    this.loadingAddVender = false;
                }
            },
            cancelEdit(){
                this.detailVendor = JSON.parse(JSON.stringify(this.CopyDetailVendor));
                this.editFile = false;
            },
            editFileData(){
                this.detailVendor = JSON.parse(JSON.stringify(this.CopyDetailVendor));
                for (const [key, value] of Object.entries(this.detailVendor)) {
                    this.$set(this.dataInputs, key, value)
                }
                this.editFile = true
            },
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            alert(title = '', text = 'Fail', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
        }
    }
</script>

<style>
    .vendor-detail-scroll {
        overflow-y: auto;
        border-radius: 0px !important;
        max-height: calc(100vh - 158px);
    }

    .dropdown-select.v-text-field {
        height: 25px;
        max-height: 25px;
    }

    .dropdown-select .v-input__control,
    .dropdown-select .v-input__slot,
    .dropdown-select .v-select__selections {
        min-height: 25px !important;
        height: 25px !important;
        padding: 0 !important;
    }

    .dropdown-select input {
        line-height: 25px;
        height: 25px;
        padding: 8px 0px !important;
        margin: 0px 10px !important;
    }

    .dropdown-select .v-input__append-inner {
        height: 25px;
        margin-top: 0 !important;
        display: flex;
        align-items: center;
    }

    .dropdown-select .v-icon {
        font-size: 18px;
    }

    @media only screen and (max-width: 600px) {
        .vendor-detail-scroll {
            max-height: calc(100vh - 238px) !important;
        }
    }
</style>